export const DetermineEnablePredicate = (
    contexts: (boolean | undefined)[],
    shouldEnable?: boolean
): boolean | undefined => {
    if (shouldEnable === undefined) {
        return undefined;
    }

    if (contexts.length === 0 || contexts.every(context => context === undefined)) {
        return undefined; // calling .every on an empty array returns true
    }

    if (contexts.every(context => context === true)) {
        return shouldEnable;
    }

    return false;
};

export const DetermineEnablePredicateLenient = (contexts: (boolean | undefined)[]): boolean | undefined => {
    if (contexts.every(context => context === undefined) || contexts.length === 0) {
        return undefined;
    }

    return contexts.some(context => context);
};
